import React, {
    useEffect,
    useMemo,
    useRef,
    useState
} from "react";
import {
  getAllTrainer,
  updateTrainer,
  getTrainerById,
  getOwnTrainerResume,
  uploadOwnResume,
} from "../../services/trainerService";
// import { uploadOwnResume } from "../../services/trainerService";
import {
    UserRound,
    Mail,
    Phone,
    MapPin,
    BriefcaseBusiness,
    GraduationCap,
    Building2,
    Pencil,
    Plus,
    Trash2,
    X,
    Save,
    Globe,
    Award,
    Code2,
    Cloud,
    Database,
    Languages,
    BookOpen,
    CheckCircle2,
    CalendarDays,
    Loader2,
    AlertCircle,
    RefreshCw,
    Camera,
    Download,
    LayoutDashboard,
    FileText,
    ClipboardList,
    UserCheck,
    ExternalLink,
    ChevronRight,
    Cake,
    Hash,
    DollarSign,
    Tag,
    MessageSquare,
    Upload,
    File as FileIcon,
    ShieldCheck
} from "lucide-react";

import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import {
    getTrainerProfile,
    saveTrainerDetails,
    updateTrainerDetails,
    addEducation,
    updateEducation,
    deleteEducation,
    addExperience,
    updateExperience,
    deleteExperience,
    uploadProfilePicture,
    getProfilePictureUrl,
    deleteProfilePicture
} from "../../services/trainerProfileService";



import { useNavigate } from "react-router-dom";

import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

import "./TrainerProfile.css";

/* =========================================================
   SWEETALERT HELPERS
   NOTE: run `npm install sweetalert2` if it isn't already
   a project dependency.
========================================================= */

const BRAND_COLOR = "#3E0F8D";
const DANGER_COLOR = "#ef4444";
const SWAL_POPUP_CLASS = "tp-swal-popup";

/* trainers.status enum values (Table: trainers) */
const STATUS_OPTIONS = [
    "APPROVED",
    "PENDING",
    "INACTIVE",
    "BLOCKED",
    "REJECTED"
];

function successToast(title, text = "") {

    Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title,
        text,
        showConfirmButton: false,
        timer: 2200,
        timerProgressBar: true,
        customClass: {
            popup: SWAL_POPUP_CLASS
        }
    });
}

function errorAlert(title, text) {

    Swal.fire({
        icon: "error",
        title,
        text,
        confirmButtonColor: DANGER_COLOR,
        customClass: {
            popup: SWAL_POPUP_CLASS
        }
    });
}

async function confirmAction({
    title,
    text = "",
    icon = "question",
    confirmButtonText = "Yes, continue",
    confirmButtonColor = BRAND_COLOR
}) {

    const result = await Swal.fire({
        title,
        text,
        icon,
        showCancelButton: true,
        confirmButtonText,
        cancelButtonText: "Cancel",
        confirmButtonColor,
        cancelButtonColor: "#746B8C",
        reverseButtons: true,
        focusCancel: true,
        customClass: {
            popup: SWAL_POPUP_CLASS
        }
    });

    return result.isConfirmed;
}


/* =========================================================
   BUILD MULTIPART FORM DATA FOR `updateTrainer`
   NOTE: updateTrainer() (trainerService.js) does a PUT with
   multipart/form-data, not JSON — so every trainer-table
   update has to go through this. Field keys below match the
   `trainers` entity property names; confirm the "resume"
   file field name against your @PutMapping controller
   (adjust the .append("resume", file) call below if your
   backend expects a different part name, e.g. "resumeFile").
========================================================= */

function buildTrainerFormData(fields) {

    const formData = new FormData();

    Object.entries(fields).forEach(
        ([key, value]) => {

            if (
                value === null ||
                value === undefined
            ) {

                formData.append(key, "");

            } else {

                formData.append(
                    key,
                    value
                );
            }
        }
    );

    return formData;
}


/* =========================================================
   MAIN COMPONENT
========================================================= */

export default function TrainerProfile() {

    const navigate = useNavigate();

    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    const [activeModal, setActiveModal] = useState(null);

    const [editingEducation, setEditingEducation] =
        useState(null);

    const [editingExperience, setEditingExperience] =
        useState(null);

    const [profileImage, setProfileImage] =
        useState(null);

    const [imageUploading, setImageUploading] =
        useState(false);

    const [cvDownloading, setCvDownloading] =
        useState(false);

    const [downloadProgress, setDownloadProgress] =
        useState(0);

    const [resumeUploading, setResumeUploading] =
        useState(false);

    const imageInputRef = useRef(null);
    const profileImageUrlRef = useRef(null);
    const resumeRef = useRef(null);
    const resumeInputRef = useRef(null);

const { trainerId } = useParams();

console.log("Trainer ID:", trainerId);
    /* =========================================================
       GET TRAINER ID
    ========================================================= */

    const getTrainerId = () => {

        try {

            const storedUser =
                localStorage.getItem("user");

            if (!storedUser) {
                return null;
            }

            const user =
                JSON.parse(storedUser);

            return (
                user?.trainerId ||
                user?.trainer_id ||
                user?.trainer?.id ||
                user?.trainer?.trainerId ||
                null
            );

        } catch (err) {

            console.error(
                "User parsing error:",
                err
            );

            return null;
        }
    };


    /* =========================================================
       RESOLVE TRAINER ID
    ========================================================= */

   const resolveTrainerId = async () => {
  // 1. Use the trainer ID from the URL, if present.
  if (trainerId && /^\d+$/.test(trainerId)) {
    return Number(trainerId);
  }

  // 2. Check the logged-in user's stored trainer ID.
  const directTrainerId = getTrainerId();

  if (directTrainerId) {
    return directTrainerId;
  }

  // 3. Match the logged-in user by email.
  try {
    const storedUser = localStorage.getItem("user");

    if (!storedUser) return null;

    const user = JSON.parse(storedUser);
    const email = (
      user?.email ||
      user?.user?.email ||
      user?.username ||
      ""
    ).trim().toLowerCase();

    if (!email) return null;

    const result = await getAllTrainer();

    const trainers = Array.isArray(result)
      ? result
      : Array.isArray(result?.data)
        ? result.data
        : Array.isArray(result?.data?.data)
          ? result.data.data
          : [];

    const matchedTrainer = trainers.find(
      (item) => item?.email?.trim().toLowerCase() === email
    );

    return matchedTrainer?.id || null;
  } catch (err) {
    console.error("Unable to resolve trainer ID:", err);
    return null;
  }
};


    /* =========================================================
       LOAD PROFILE
    ========================================================= */

    const loadProfile = async () => {

        try {

            setLoading(true);
            setError("");

            const trainerId =
                await resolveTrainerId();

            if (!trainerId) {

                throw new Error(
                    "Trainer ID not found. Please login again."
                );
            }

            const response = await getTrainerProfile(trainerId);

// Support either a normal object or an Axios-style response.
// API 1: Fetch trainer details, education and experience
const profileResponse = await getTrainerProfile(trainerId);

const profileData =
  profileResponse?.data ?? profileResponse;

// API 2: Fetch the basic trainer record
const trainerResponse = await getTrainerById(trainerId);

const trainerData =
  trainerResponse?.data?.data ??
  trainerResponse?.data?.trainer ??
  trainerResponse?.data ??
  trainerResponse?.trainer ??
  trainerResponse;

// Combine both API responses
const combinedProfile = {
  ...profileData,
  trainer:
    profileData?.trainer ??
    trainerData?.trainer ??
    trainerData,
};

console.log("Basic trainer record:", trainerData);
console.log("Combined trainer profile:", combinedProfile);

setProfile(combinedProfile);

            /* =============================================
               LOAD PROFILE IMAGE
            ============================================= */

            try {

                const imageUrl =
                    getProfilePictureUrl(
                        trainerId
                    );

                const token =
                    localStorage.getItem("token");

                const response =
                    await fetch(
                        `${imageUrl}?t=${Date.now()}`,
                        {
                            headers: {
                                ...(token
                                    ? {
                                        Authorization:
                                            `Bearer ${token}`
                                    }
                                    : {})
                            }
                        }
                    );

                if (response.ok) {

                    const blob =
                        await response.blob();

                    if (
                        blob &&
                        blob.size > 0
                    ) {

                        const objectUrl =
                            URL.createObjectURL(blob);

                        if (
                            profileImageUrlRef.current
                        ) {

                            URL.revokeObjectURL(
                                profileImageUrlRef.current
                            );
                        }

                        profileImageUrlRef.current =
                            objectUrl;

                        setProfileImage(
                            objectUrl
                        );
                    }

                } else {

                    setProfileImage(null);
                }

            } catch (imageError) {

                console.warn(
                    "Unable to load profile image:",
                    imageError
                );

            }

        } catch (err) {

            console.error(
                "Profile loading error:",
                err
            );

            setError(
                err?.response?.data?.message ||
                err?.message ||
                "Unable to load trainer profile."
            );

        } finally {

            setLoading(false);
        }
    };


    useEffect(() => {

        loadProfile();

    }, []);


    /* =========================================================
       IMAGE CLEANUP
    ========================================================= */

    useEffect(() => {

        return () => {

            if (
                profileImageUrlRef.current
            ) {

                URL.revokeObjectURL(
                    profileImageUrlRef.current
                );

                profileImageUrlRef.current =
                    null;
            }

        };

    }, []);


    /* =========================================================
       DATA
    ========================================================= */

   const trainer =
  profile?.trainer ||
  profile?.trainerDetails ||
  profile?.data?.trainer ||
  profile?.data ||
  profile ||
  {};

    const details =
        profile?.details || {};

    const education =
        Array.isArray(profile?.education)
            ? profile.education
            : [];

    const experience =
        Array.isArray(profile?.experience)
            ? profile.experience
            : [];


    /* =========================================================
       SKILLS
    ========================================================= */

   const skills = useMemo(() => {
  const allSkills = [
    details.technicalSkills,
    details.programmingLanguages,
    details.frameworks,
    details.databaseTechnologies,
    details.cloudTools,
    details.devopsTools,

    // Fallback to skills stored in the basic Trainer API
    trainer.skills,
  ]
    .filter(
      (value) =>
        typeof value === "string" && value.trim() !== ""
    )
    .join(",");

  return [
    ...new Set(
      allSkills
        .split(/[,|\n]/)
        .map((item) => item.trim())
        .filter(Boolean)
    ),
  ];
}, [details, trainer]);
    /* =========================================================
       PROFILE IMAGE UPLOAD
    ========================================================= */

    const handleProfileImage = async (event) => {

        const file =
            event.target.files?.[0];

        if (!file) {
            return;
        }

        const allowedTypes = [
            "image/jpeg",
            "image/png",
            "image/webp"
        ];

        if (
            !allowedTypes.includes(file.type)
        ) {

            errorAlert(
                "Unsupported file type",
                "Only JPG, PNG and WEBP images are allowed."
            );

            event.target.value = "";

            return;
        }

        if (
            file.size > 5 * 1024 * 1024
        ) {

            errorAlert(
                "File too large",
                "Profile picture must be smaller than 5 MB."
            );

            event.target.value = "";

            return;
        }

        const previousImage =
            profileImage;

        const previewUrl =
            URL.createObjectURL(file);

        try {

            setImageUploading(true);

            setProfileImage(
                previewUrl
            );

            const trainerId =
                await resolveTrainerId();

            if (!trainerId) {

                throw new Error(
                    "Trainer ID not found."
                );
            }

            await uploadProfilePicture(
                trainerId,
                file
            );

            const token =
                localStorage.getItem("token");

            const response =
                await fetch(
                    `${getProfilePictureUrl(
                        trainerId
                    )}?t=${Date.now()}`,
                    {
                        headers: {
                            ...(token
                                ? {
                                    Authorization:
                                        `Bearer ${token}`
                                }
                                : {})
                        }
                    }
                );

            if (!response.ok) {

                throw new Error(
                    "Profile picture uploaded but could not be loaded."
                );
            }

            const blob =
                await response.blob();

            const serverImageUrl =
                URL.createObjectURL(blob);

            if (
                profileImageUrlRef.current
            ) {

                URL.revokeObjectURL(
                    profileImageUrlRef.current
                );
            }

            profileImageUrlRef.current =
                serverImageUrl;

            setProfileImage(
                serverImageUrl
            );

            URL.revokeObjectURL(
                previewUrl
            );

            successToast(
                "Profile picture updated"
            );

        } catch (err) {

            console.error(
                "Profile picture upload error:",
                err
            );

            try {

                URL.revokeObjectURL(
                    previewUrl
                );

            } catch {}

            setProfileImage(
                previousImage || null
            );

            errorAlert(
                "Upload failed",
                err?.response?.data?.message ||
                err?.message ||
                "Unable to upload profile picture."
            );

        } finally {

            setImageUploading(false);

            event.target.value = "";
        }
    };


    /* =========================================================
       DELETE PROFILE IMAGE
    ========================================================= */

    const handleDeleteProfileImage =
        async () => {

            if (!profileImage) {
                return;
            }

            const confirmed =
                await confirmAction({
                    title: "Remove profile picture?",
                    text: "This will delete your current profile photo.",
                    icon: "warning",
                    confirmButtonText: "Yes, remove it",
                    confirmButtonColor: DANGER_COLOR
                });

            if (!confirmed) {
                return;
            }

            try {

                setImageUploading(true);

                const trainerId =
                    await resolveTrainerId();

                if (!trainerId) {

                    throw new Error(
                        "Trainer ID not found."
                    );
                }

                await deleteProfilePicture(
                    trainerId
                );

                if (
                    profileImageUrlRef.current
                ) {

                    URL.revokeObjectURL(
                        profileImageUrlRef.current
                    );

                    profileImageUrlRef.current =
                        null;
                }

                setProfileImage(null);

                successToast(
                    "Profile picture removed"
                );

            } catch (err) {

                console.error(err);

                errorAlert(
                    "Removal failed",
                    err?.response?.data?.message ||
                    err?.message ||
                    "Unable to remove profile picture."
                );

            } finally {

                setImageUploading(false);
            }
        };


    /* =========================================================
       PROFILE SAVE
    ========================================================= */

    const handleProfileSave =
        async (formData) => {

            const confirmed =
                await confirmAction({
                    title: "Save profile changes?",
                    text: "Your professional profile will be updated with the new information.",
                    icon: "question",
                    confirmButtonText: "Yes, save changes"
                });

            if (!confirmed) {
                return;
            }

            try {

                setSaving(true);

                const trainerId =
                    await resolveTrainerId();

                if (!trainerId) {

                    throw new Error(
                        "Trainer ID not found."
                    );
                }

                if (profile?.details) {

                    await updateTrainerDetails(
                        trainerId,
                        formData
                    );

                } else {

                    await saveTrainerDetails(
                        trainerId,
                        formData
                    );
                }

                closeModal();

                await loadProfile();

                successToast(
                    "Profile updated successfully"
                );

            } catch (err) {

                console.error(err);

                errorAlert(
                    "Update failed",
                    err?.response?.data?.message ||
                    err?.message ||
                    "Unable to update profile."
                );

            } finally {

                setSaving(false);
            }
        };


    /* =========================================================
       TRAINER (BASIC) INFO SAVE — writes to the `trainers` table
    ========================================================= */

    const handleTrainerInfoSave =
        async (formData) => {

            const confirmed =
                await confirmAction({
                    title: "Save trainer information?",
                    text: "Your basic trainer details will be updated.",
                    icon: "question",
                    confirmButtonText: "Yes, save changes"
                });

            if (!confirmed) {
                return;
            }

            try {

                setSaving(true);

                const trainerId =
                    await resolveTrainerId();

                if (!trainerId) {

                    throw new Error(
                        "Trainer ID not found."
                    );
                }

                await updateTrainer(
                    trainerId,
                    buildTrainerFormData(
                        formData
                    )
                );

                closeModal();

                await loadProfile();

                successToast(
                    "Trainer information updated successfully"
                );

            } catch (err) {

                console.error(err);

                errorAlert(
                    "Update failed",
                    err?.response?.data?.message ||
                    err?.message ||
                    "Unable to update trainer information."
                );

            } finally {

                setSaving(false);
            }
        };


    /* =========================================================
       RESUME UPLOAD — trainers.resume_name / resume_type / resume_data
    ========================================================= */

    


    /* =========================================================
       RESUME DOWNLOAD
    ========================================================= */

    const handleResumeUpload = async (event) => {
  const file = event.target.files?.[0];

  if (!file) return;

  const allowedExtensions = ["pdf", "doc", "docx"];
  const extension = file.name.split(".").pop().toLowerCase();

  if (!allowedExtensions.includes(extension)) {
    errorAlert(
      "Unsupported file type",
      "Only PDF, DOC and DOCX files are allowed."
    );
    event.target.value = "";
    return;
  }

  if (file.size > 10 * 1024 * 1024) {
    errorAlert(
      "File too large",
      "Resume must be smaller than 10 MB."
    );
    event.target.value = "";
    return;
  }

  try {
    setResumeUploading(true);

    const trainerId = await resolveTrainerId();

    if (!trainerId) {
      throw new Error("Trainer ID not found.");
    }

    const user = JSON.parse(
      localStorage.getItem("user") || "{}"
    );

    if (!user.email) {
      throw new Error("Please log in again.");
    }

    await uploadOwnResume(trainerId, file);
    await loadProfile();

    successToast(
      "Resume updated",
      "Your resume was uploaded successfully."
    );
  } catch (err) {
    console.error("Resume upload error:", err);

    let message =
      err.response?.data?.message ||
      err.message ||
      "Unable to upload resume.";

    if (err.response?.status === 401) {
      message = "Authentication is required. Please log in again.";
    } else if (err.response?.status === 403) {
      message = "You are not authorized to update this resume.";
    } else if (err.response?.status === 415) {
      message = "The backend must accept multipart/form-data.";
    }

    errorAlert("Upload failed", message);
  } finally {
    setResumeUploading(false);
    event.target.value = "";
  }
};

const handleResumeDownload = async () => {
  try {
    const trainerId = await resolveTrainerId();

    if (!trainerId) {
      throw new Error("Trainer ID not found.");
    }

    console.log("Downloading resume for trainer:", trainerId);
    console.log(
      "Token exists:",
      !!localStorage.getItem("token")
    );
const token = localStorage.getItem("token");

console.log("Token exists:", !!token);
console.log("Token value:", token ? "Present" : "Missing");
    // Call the API to inspect the actual backend response.
    const response = await getOwnTrainerResume(trainerId);
    const blob = response.data;

    if (!(blob instanceof Blob) || blob.size === 0) {
      throw new Error("Resume file is empty or unavailable.");
    }

    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = objectUrl;
    link.download = trainer?.resumeName || "resume.pdf";

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.setTimeout(() => {
      URL.revokeObjectURL(objectUrl);
    }, 1000);

  } catch (err) {
    console.error("Resume download error:", err);
    console.error("HTTP status:", err.response?.status);
    console.error("Backend response:", err.response?.data);

    let message = err.message || "Unable to download resume.";

    if (err.response?.status === 401) {
      message = "Backend returned 401: authentication is required or failed.";
    } else if (err.response?.status === 403) {
      message = "Backend returned 403: access is forbidden.";
    } else if (err.response?.status === 404) {
      message = "Backend returned 404: resume or endpoint not found.";
    }

    errorAlert("Download failed", message);
  }
};



    /* =========================================================
       EDUCATION SAVE
    ========================================================= */

    const handleEducationSave =
        async (data) => {

            const isEdit =
                Boolean(editingEducation?.id);

            const confirmed =
                await confirmAction({
                    title: isEdit
                        ? "Save changes to this education record?"
                        : "Add this education record?",
                    icon: "question",
                    confirmButtonText: isEdit
                        ? "Yes, save changes"
                        : "Yes, add it"
                });

            if (!confirmed) {
                return;
            }

            try {

                setSaving(true);

                const trainerId =
                    await resolveTrainerId();

                if (!trainerId) {

                    throw new Error(
                        "Trainer ID not found."
                    );
                }

                if (isEdit) {

                    await updateEducation(
                        editingEducation.id,
                        data
                    );

                } else {

                    await addEducation(
                        trainerId,
                        data
                    );
                }

                closeModal();

                await loadProfile();

                successToast(
                    isEdit
                        ? "Education updated successfully"
                        : "Education added successfully"
                );

            } catch (err) {

                console.error(err);

                errorAlert(
                    "Save failed",
                    err?.response?.data?.message ||
                    err?.message ||
                    "Unable to save education."
                );

            } finally {

                setSaving(false);
            }
        };


    /* =========================================================
       EDUCATION DELETE
    ========================================================= */

    const handleEducationDelete =
        async (id) => {

            const confirmed =
                await confirmAction({
                    title: "Delete this education record?",
                    text: "This action cannot be undone.",
                    icon: "warning",
                    confirmButtonText: "Yes, delete it",
                    confirmButtonColor: DANGER_COLOR
                });

            if (!confirmed) {
                return;
            }

            try {

                setSaving(true);

                await deleteEducation(id);

                await loadProfile();

                successToast(
                    "Education deleted"
                );

            } catch (err) {

                console.error(err);

                errorAlert(
                    "Delete failed",
                    err?.response?.data?.message ||
                    err?.message ||
                    "Unable to delete education."
                );

            } finally {

                setSaving(false);
            }
        };


    /* =========================================================
       EXPERIENCE SAVE
    ========================================================= */

    const handleExperienceSave =
        async (data) => {

            const isEdit =
                Boolean(editingExperience?.id);

            const confirmed =
                await confirmAction({
                    title: isEdit
                        ? "Save changes to this experience?"
                        : "Add this work experience?",
                    icon: "question",
                    confirmButtonText: isEdit
                        ? "Yes, save changes"
                        : "Yes, add it"
                });

            if (!confirmed) {
                return;
            }

            try {

                setSaving(true);

                const trainerId =
                    await resolveTrainerId();

                if (!trainerId) {

                    throw new Error(
                        "Trainer ID not found."
                    );
                }

                if (isEdit) {

                    await updateExperience(
                        editingExperience.id,
                        data
                    );

                } else {

                    await addExperience(
                        trainerId,
                        data
                    );
                }

                closeModal();

                await loadProfile();

                successToast(
                    isEdit
                        ? "Experience updated successfully"
                        : "Experience added successfully"
                );

            } catch (err) {

                console.error(err);

                errorAlert(
                    "Save failed",
                    err?.response?.data?.message ||
                    err?.message ||
                    "Unable to save experience."
                );

            } finally {

                setSaving(false);
            }
        };


    /* =========================================================
       EXPERIENCE DELETE
    ========================================================= */

    const handleExperienceDelete =
        async (id) => {

            const confirmed =
                await confirmAction({
                    title: "Delete this experience record?",
                    text: "This action cannot be undone.",
                    icon: "warning",
                    confirmButtonText: "Yes, delete it",
                    confirmButtonColor: DANGER_COLOR
                });

            if (!confirmed) {
                return;
            }

            try {

                setSaving(true);

                await deleteExperience(id);

                await loadProfile();

                successToast(
                    "Experience deleted"
                );

            } catch (err) {

                console.error(err);

                errorAlert(
                    "Delete failed",
                    err?.response?.data?.message ||
                    err?.message ||
                    "Unable to delete experience."
                );

            } finally {

                setSaving(false);
            }
        };


    /* =========================================================
       MODAL
    ========================================================= */

    const closeModal = () => {

        setActiveModal(null);

        setEditingEducation(null);

        setEditingExperience(null);
    };


    const openProfileEdit = () => {

        setEditingEducation(null);

        setEditingExperience(null);

        setActiveModal("profile");
    };


    const openTrainerInfoEdit = () => {

        setEditingEducation(null);

        setEditingExperience(null);

        setActiveModal("trainerInfo");
    };


    const openEducationAdd = () => {

        setEditingEducation(null);

        setEditingExperience(null);

        setActiveModal("education");
    };


    const openEducationEdit = item => {

        setEditingEducation(item);

        setEditingExperience(null);

        setActiveModal("education");
    };


    const openExperienceAdd = () => {

        setEditingExperience(null);

        setEditingEducation(null);

        setActiveModal("experience");
    };


    const openExperienceEdit = item => {

        setEditingExperience(item);

        setEditingEducation(null);

        setActiveModal("experience");
    };


    /* =========================================================
       PROFILE COMPLETION
    ========================================================= */

    const completionFields = [
        details.professionalTitle,
        details.profileSummary,
        details.currentOrganization,
        details.currentDesignation,
        details.technicalSkills,
        details.certifications,
        education.length > 0,
        experience.length > 0,
        profileImage
    ];

    const completedFields =
        completionFields.filter(Boolean).length;

    const completion =
        Math.round(
            (
                completedFields /
                completionFields.length
            ) * 100
        );


    /* =========================================================
       DOWNLOAD CV (with real progress feedback)
    ========================================================= */

    const handleDownloadCV = async () => {

        if (!resumeRef.current) {

            errorAlert(
                "CV not available",
                "CV content is not available."
            );

            return;
        }

        try {

            setCvDownloading(true);
            setDownloadProgress(5);

            const element =
                resumeRef.current;

            // Stage 1 — preparing the document for capture
            setDownloadProgress(15);

            const canvas =
                await html2canvas(
                    element,
                    {
                        scale: 2,
                        useCORS: true,
                        backgroundColor: "#ffffff",
                        logging: false,
                        onclone: () => {

                            // Canvas capture is under way
                            setDownloadProgress(45);
                        }
                    }
                );

            // Stage 2 — canvas captured
            setDownloadProgress(65);

            const imgData =
                canvas.toDataURL(
                    "image/png"
                );

            // Stage 3 — building the PDF
            setDownloadProgress(80);

            const pdf =
                new jsPDF(
                    "p",
                    "mm",
                    "a4"
                );

            const pdfWidth =
                pdf.internal.pageSize.getWidth();

            const pdfHeight =
                pdf.internal.pageSize.getHeight();

            const imgWidth =
                pdfWidth;

            const imgHeight =
                (
                    canvas.height *
                    imgWidth
                ) /
                canvas.width;

            let heightLeft =
                imgHeight;

            let position = 0;

            pdf.addImage(
                imgData,
                "PNG",
                0,
                position,
                imgWidth,
                imgHeight
            );

            heightLeft -= pdfHeight;

            while (
                heightLeft > 0
            ) {

                position =
                    heightLeft -
                    imgHeight;

                pdf.addPage();

                pdf.addImage(
                    imgData,
                    "PNG",
                    0,
                    position,
                    imgWidth,
                    imgHeight
                );

                heightLeft -=
                    pdfHeight;
            }

            // Stage 4 — saving the file
            setDownloadProgress(95);

            const safeName =
                (
                    trainer.name ||
                    "Trainer"
                )
                    .replace(
                        /[^a-zA-Z0-9-_ ]/g,
                        ""
                    )
                    .trim()
                    .replace(
                        /\s+/g,
                        "_"
                    );

            pdf.save(
                `${safeName || "Trainer"}_CV.pdf`
            );

            setDownloadProgress(100);

            successToast(
                "CV downloaded",
                "Your resume has been saved to your device."
            );

        } catch (err) {

            console.error(
                "CV download error:",
                err
            );

            errorAlert(
                "Download failed",
                "Unable to generate CV. Please try again."
            );

        } finally {

            // Let the bar visibly reach 100% before resetting
            setTimeout(() => {

                setCvDownloading(false);
                setDownloadProgress(0);

            }, 500);
        }
    };


    /* =========================================================
       NAVIGATION
    ========================================================= */

    const goTo =
        path => {

            navigate(path);
        };


    /* =========================================================
       LOADING
    ========================================================= */

    if (loading) {

        return (

            <div className="tp-state">

                <Loader2
                    className="tp-spin"
                    size={34}
                />

                <h3>
                    Loading Profile
                </h3>

                <p>
                    Please wait while we load your
                    trainer profile.
                </p>

            </div>
        );
    }


    /* =========================================================
       ERROR
    ========================================================= */

    if (error) {

        return (

            <div className="tp-state tp-error-state">

                <AlertCircle size={42} />

                <h3>
                    Unable to load profile
                </h3>

                <p>
                    {error}
                </p>

                <button
                    type="button"
                    className="tp-primary-btn"
                    onClick={loadProfile}
                >

                    <RefreshCw size={16} />

                    Try Again

                </button>

            </div>
        );
    }


    /* =========================================================
       MAIN UI
    ========================================================= */

    return (

        <div className="trainer-profile-page">


            {/* =================================================
                HERO
            ================================================= */}

            <section className="tp-hero">

                <div className="tp-profile-photo-wrapper">

                    {profileImage ? (

                        <img
                            src={profileImage}
                            alt={
                                trainer.name ||
                                "Trainer"
                            }
                            className="tp-profile-photo"
                        />

                    ) : (

                        <div className="tp-avatar">

                            {trainer.name
                                ? trainer.name
                                    .charAt(0)
                                    .toUpperCase()
                                : "T"}

                        </div>
                    )}


                    <button
                        type="button"
                        className="tp-camera-btn"
                        onClick={() =>
                            imageInputRef.current?.click()
                        }
                        disabled={imageUploading}
                        title="Change profile picture"
                    >

                        {imageUploading ? (

                            <Loader2
                                size={15}
                                className="tp-spin"
                            />

                        ) : (

                            <Camera size={15} />

                        )}

                    </button>


                    <input
                        ref={imageInputRef}
                        type="file"
                        accept="image/png,image/jpeg,image/webp"
                        hidden
                        onChange={
                            handleProfileImage
                        }
                        disabled={
                            imageUploading
                        }
                    />


                    {profileImage &&
                        !imageUploading && (

                            <button
                                type="button"
                                className="tp-remove-photo-btn"
                                onClick={
                                    handleDeleteProfileImage
                                }
                                title="Remove profile picture"
                            >

                                <Trash2 size={13} />

                            </button>

                        )}

                </div>


                <div className="tp-hero-content">

                    <div className="tp-name-row">

                        <div>

                          <h2>
  {trainer?.name ||
    trainer?.fullName ||
    trainer?.trainerName ||
    "Trainer Name"}
</h2>

                            <p className="tp-title">

                               {details.professionalTitle ||
  trainer.professionalTitle ||
  "Not specified"}
                            </p>

                        </div>


                        <span className="tp-status">

                            <CheckCircle2 size={15} />

                            {trainer.status ||
                                "ACTIVE"}

                        </span>

                    </div>


                    <div className="tp-contact-row">

                        {trainer.email && (

                            <span>

                                <Mail size={15} />

                                {trainer.email}

                            </span>

                        )}


                        {trainer.phone && (

                            <span>

                                <Phone size={15} />

                                {trainer.phone}

                            </span>

                        )}


                        {(trainer.city ||
                            trainer.state) && (

                            <span>

                                <MapPin size={15} />

                                {[
                                    trainer.city,
                                    trainer.state
                                ]
                                    .filter(Boolean)
                                    .join(", ")}

                            </span>

                        )}

                    </div>

                </div>


                <button
                    type="button"
                    className="tp-edit-profile"
                    onClick={
                        openProfileEdit
                    }
                >

                    <Pencil size={16} />

                    Edit Profile

                </button>

            </section>


            {/* =================================================
                STATS
            ================================================= */}

            <section className="tp-stats">

                <Stat
                    icon={
                        <BriefcaseBusiness />
                    }
                    value={
                        details.totalExperience ??
                        trainer.experience ??
                        0
                    }
                    label="Years Experience"
                />


                <Stat
                    icon={
                        <BookOpen />
                    }
                    value={
                        details.trainingExperience ??
                        0
                    }
                    label="Training Experience"
                />


                <Stat
                    icon={
                        <GraduationCap />
                    }
                    value={
                        education.length
                    }
                    label="Education"
                />


                <Stat
                    icon={
                        <Building2 />
                    }
                    value={
                        experience.length
                    }
                    label="Work Experience"
                />

            </section>


            {/* =================================================
                70 / 30 LAYOUT
            ================================================= */}

            <div className="tp-dashboard-layout">


                {/* =================================================
                    LEFT 70%
                ================================================= */}

                <main className="tp-main-content">


                    {/* =============================================
                        TRAINER INFORMATION (trainers table)
                    ============================================= */}

                    <ProfileCard
                        title="Trainer Information"
                        icon={<ShieldCheck />}
                        action={

                            <button
                                type="button"
                                className="tp-small-btn"
                                onClick={
                                    openTrainerInfoEdit
                                }
                            >

                                <Pencil size={15} />

                                Edit Details

                            </button>

                        }
                    >

                        <div className="tp-tech-grid">

                            <TechItem
                                icon={<Phone />}
                                title="Secondary Phone"
                                value={
                                    trainer.secondaryPhone
                                }
                            />

                            <TechItem
                                icon={<Mail />}
                                title="Secondary Email"
                                value={
                                    trainer.secondaryEmail
                                }
                            />

                            <TechItem
                                icon={<Cake />}
                                title="Age"
                                value={
                                    trainer.age
                                }
                            />

                            <TechItem
                                icon={<BriefcaseBusiness />}
                                title="Experience (Years)"
                                value={
                                    trainer.experience
                                }
                            />

                            <TechItem
                                icon={<Hash />}
                                title="Pincode"
                                value={
                                    trainer.pincode
                                }
                            />

                            <TechItem
                                icon={<Tag />}
                                title="Source"
                                value={
                                    trainer.source
                                }
                            />

                            <TechItem
                                icon={<DollarSign />}
                                title="Rate"
                                value={
                                    trainer.rate
                                }
                            />

                            <TechItem
                                icon={<ShieldCheck />}
                                title="Status"
                                value={
                                    trainer.status
                                }
                            />

                        </div>


                        {trainer.skills && (

                            <div className="tp-summary">

                                <label>
                                    Skills
                                </label>

                                <p>
                                    {
                                        trainer.skills
                                    }
                                </p>

                            </div>

                        )}


                        {trainer.remark && (

                            <div className="tp-summary">

                                <label>
                                    Remark
                                </label>

                                <p>
                                    {
                                        trainer.remark
                                    }
                                </p>

                            </div>

                        )}


                        <div className="tp-resume-row">

                            <div className="tp-resume-info">

                                <FileIcon size={18} />

                                <span>

                                    {
                                        trainer.resumeName ||
                                        "No resume uploaded"
                                    }

                                    {trainer.resumeType && (

                                        <em>
                                            {" "}
                                            (
                                            {
                                                trainer.resumeType
                                            }
                                            )
                                        </em>

                                    )}

                                </span>

                            </div>


                            <div className="tp-resume-actions">

                                {trainer.resumeName && (

                                    <button
                                        type="button"
                                        className="tp-small-btn"
                                        onClick={
                                            handleResumeDownload
                                        }
                                    >

                                        <Download size={15} />

                                        Download

                                    </button>

                                )}


                                <button
                                    type="button"
                                    className="tp-small-btn"
                                    onClick={() =>
                                        resumeInputRef.current?.click()
                                    }
                                    disabled={
                                        resumeUploading
                                    }
                                >

                                    {resumeUploading ? (

                                        <>
                                            <Loader2
                                                size={15}
                                                className="tp-spin"
                                            />
                                            Uploading...
                                        </>

                                    ) : (

                                        <>
                                            <Upload size={15} />
                                            {trainer.resumeName
                                                ? "Replace"
                                                : "Upload"}
                                        </>

                                    )}

                                </button>


                                <input
                                    ref={resumeInputRef}
                                    type="file"
                                    accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                    hidden
                                    onChange={
                                        handleResumeUpload
                                    }
                                    disabled={
                                        resumeUploading
                                    }
                                />

                            </div>

                        </div>

                    </ProfileCard>


                    {/* =============================================
                        PROFESSIONAL PROFILE
                    ============================================= */}

                    <ProfileCard
                        title="Professional Profile"
                        icon={<UserRound />}
                    >

                        <div className="tp-about">

                            <div>

                                <label>
                                    Professional Title
                                </label>

                                <strong>
                                    {details.professionalTitle ||
                                        details.currentDesignation ||
                                        "Not specified"}
                                </strong>

                            </div>


                            <div>

                                <label>
                                    Current Organization
                                </label>

                                <strong>
                                    {details.currentOrganization ||
  trainer.currentOrganization ||
  "Not specified"}
                                </strong>

                            </div>


                            <div>

                                <label>
                                    Current Designation
                                </label>

                                <strong>
                                   {details.currentDesignation ||
  trainer.currentDesignation ||
  trainer.designation ||
  "Not specified"}
                                </strong>

                            </div>


                            <div>

                                <label>
                                    Teaching Mode
                                </label>

                                <strong>
                                    {details.teachingMode ||
  trainer.teachingMode ||
  "Not specified"}
                                </strong>

                            </div>

                        </div>


                        {details.profileSummary && (

                            <div className="tp-summary">

                                <label>
                                    Profile Summary
                                </label>

                                <p>
                                    {
                                        details.profileSummary
                                    }
                                </p>

                            </div>

                        )}

                    </ProfileCard>


                    {/* =============================================
                        TECHNICAL SKILLS
                    ============================================= */}

                    <ProfileCard
                        title="Technical Skills"
                        icon={<Code2 />}
                    >

                        {skills.length > 0 ? (

                            <div className="tp-skills">

                                {skills.map(
                                    (
                                        skill,
                                        index
                                    ) => (

                                        <span
                                            className="tp-skill"
                                            key={
                                                `${skill}-${index}`
                                            }
                                        >
                                            {skill}
                                        </span>

                                    )
                                )}

                            </div>

                        ) : (

                            <Empty
                                text="No technical skills added."
                            />

                        )}


                        <div className="tp-tech-grid">

                            <TechItem
                                icon={
                                    <Code2 />
                                }
                                title="Programming Languages"
                                value={
                                    details.programmingLanguages
                                }
                            />

                            <TechItem
                                icon={
                                    <Code2 />
                                }
                                title="Frameworks"
                                value={
                                    details.frameworks
                                }
                            />

                            <TechItem
                                icon={
                                    <Database />
                                }
                                title="Databases"
                                value={
                                    details.databaseTechnologies
                                }
                            />

                            <TechItem
                                icon={
                                    <Cloud />
                                }
                                title="Cloud"
                                value={
                                    details.cloudTools
                                }
                            />

                            <TechItem
                                icon={
                                    <Code2 />
                                }
                                title="DevOps"
                                value={
                                    details.devopsTools
                                }
                            />

                        </div>

                    </ProfileCard>


                    {/* =============================================
                        EDUCATION
                    ============================================= */}

                    <ProfileCard
                        title="Education"
                        icon={
                            <GraduationCap />
                        }
                        action={

                            <button
                                type="button"
                                className="tp-small-btn"
                                onClick={
                                    openEducationAdd
                                }
                            >

                                <Plus size={15} />

                                Add Education

                            </button>

                        }
                    >

                        {education.length === 0 ? (

                            <Empty
                                text="No education records added."
                            />

                        ) : (

                            <div className="tp-timeline">

                                {education.map(
                                    item => (

                                        <div
                                            className="tp-timeline-item"
                                            key={
                                                item.id
                                            }
                                        >

                                            <div className="tp-timeline-dot">

                                                <GraduationCap
                                                    size={15}
                                                />

                                            </div>


                                            <div className="tp-timeline-content">

                                                <div className="tp-item-top">

                                                    <div>

                                                        <h3>
                                                            {
                                                                item.degree ||
                                                                "Degree"
                                                            }
                                                        </h3>

                                                        {
                                                            item.specialization && (
                                                                <p>
                                                                    {
                                                                        item.specialization
                                                                    }
                                                                </p>
                                                            )
                                                        }

                                                    </div>


                                                    <div className="tp-actions">

                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                openEducationEdit(
                                                                    item
                                                                )
                                                            }
                                                            title="Edit education"
                                                        >

                                                            <Pencil
                                                                size={15}
                                                            />

                                                        </button>


                                                        <button
                                                            type="button"
                                                            className="danger"
                                                            onClick={() =>
                                                                handleEducationDelete(
                                                                    item.id
                                                                )
                                                            }
                                                            title="Delete education"
                                                        >

                                                            <Trash2
                                                                size={15}
                                                            />

                                                        </button>

                                                    </div>

                                                </div>


                                                <div className="tp-meta">

                                                    {item.college && (

                                                        <span>

                                                            <Building2
                                                                size={14}
                                                            />

                                                            {
                                                                item.college
                                                            }

                                                        </span>

                                                    )}


                                                    {item.university && (

                                                        <span>

                                                            <GraduationCap
                                                                size={14}
                                                            />

                                                            {
                                                                item.university
                                                            }

                                                        </span>

                                                    )}


                                                    {(item.startYear ||
                                                        item.endYear) && (

                                                            <span>

                                                                <CalendarDays
                                                                    size={14}
                                                                />

                                                                {
                                                                    item.startYear ||
                                                                    "-"
                                                                }

                                                                {" - "}

                                                                {
                                                                    item.endYear ||
                                                                    "Present"
                                                                }

                                                            </span>

                                                        )}

                                                </div>


                                                <div className="tp-score">

                                                    {item.cgpa != null && (

                                                        <span>

                                                            CGPA:

                                                            <b>
                                                                {
                                                                    item.cgpa
                                                                }
                                                            </b>

                                                        </span>

                                                    )}


                                                    {item.percentage != null && (

                                                        <span>

                                                            Percentage:

                                                            <b>
                                                                {
                                                                    item.percentage
                                                                }%
                                                            </b>

                                                        </span>

                                                    )}

                                                </div>


                                                {item.description && (

                                                    <p className="tp-item-description">

                                                        {
                                                            item.description
                                                        }

                                                    </p>

                                                )}

                                            </div>

                                        </div>

                                    )
                                )}

                            </div>

                        )}

                    </ProfileCard>


                    {/* =============================================
                        EXPERIENCE
                    ============================================= */}

                    <ProfileCard
                        title="Professional Experience"
                        icon={
                            <BriefcaseBusiness />
                        }
                        action={

                            <button
                                type="button"
                                className="tp-small-btn"
                                onClick={
                                    openExperienceAdd
                                }
                            >

                                <Plus size={15} />

                                Add Experience

                            </button>

                        }
                    >

                        {experience.length === 0 ? (

                            <Empty
                                text="No work experience added."
                            />

                        ) : (

                            <div className="tp-timeline">

                                {experience.map(
                                    item => (

                                        <div
                                            className="tp-timeline-item"
                                            key={
                                                item.id
                                            }
                                        >

                                            <div className="tp-timeline-dot">

                                                <BriefcaseBusiness
                                                    size={15}
                                                />

                                            </div>


                                            <div className="tp-timeline-content">

                                                <div className="tp-item-top">

                                                    <div>

                                                        <h3>
                                                            {
                                                                item.designation ||
                                                                "Designation"
                                                            }
                                                        </h3>

                                                        <p>
                                                            {
                                                                item.companyName ||
                                                                "Company"
                                                            }
                                                        </p>

                                                    </div>


                                                    <div className="tp-actions">

                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                openExperienceEdit(
                                                                    item
                                                                )
                                                            }
                                                            title="Edit experience"
                                                        >

                                                            <Pencil
                                                                size={15}
                                                            />

                                                        </button>


                                                        <button
                                                            type="button"
                                                            className="danger"
                                                            onClick={() =>
                                                                handleExperienceDelete(
                                                                    item.id
                                                                )
                                                            }
                                                            title="Delete experience"
                                                        >

                                                            <Trash2
                                                                size={15}
                                                            />

                                                        </button>

                                                    </div>

                                                </div>


                                                <div className="tp-meta">

                                                    {item.location && (

                                                        <span>

                                                            <MapPin
                                                                size={14}
                                                            />

                                                            {
                                                                item.location
                                                            }

                                                        </span>

                                                    )}


                                                    {item.employmentType && (

                                                        <span>

                                                            <BriefcaseBusiness
                                                                size={14}
                                                            />

                                                            {
                                                                item.employmentType
                                                            }

                                                        </span>

                                                    )}


                                                    {(item.startDate ||
                                                        item.endDate ||
                                                        item.isCurrent) && (

                                                            <span>

                                                                <CalendarDays
                                                                    size={14}
                                                                />

                                                                {
                                                                    formatDate(
                                                                        item.startDate
                                                                    )
                                                                }

                                                                {" - "}

                                                                {
                                                                    item.isCurrent
                                                                        ? "Present"
                                                                        : formatDate(
                                                                            item.endDate
                                                                        )
                                                                }

                                                            </span>

                                                        )}

                                                </div>


                                                {item.technologiesUsed && (

                                                    <div className="tp-used-tech">

                                                        {
                                                            item.technologiesUsed
                                                                .split(
                                                                    /[,|\n]/
                                                                )
                                                                .map(
                                                                    (
                                                                        tech,
                                                                        index
                                                                    ) => (

                                                                        <span
                                                                            key={
                                                                                index
                                                                            }
                                                                        >
                                                                            {
                                                                                tech.trim()
                                                                            }
                                                                        </span>

                                                                    )
                                                                )
                                                        }

                                                    </div>

                                                )}


                                                {item.jobDescription && (

                                                    <p className="tp-item-description">

                                                        {
                                                            item.jobDescription
                                                        }

                                                    </p>

                                                )}

                                            </div>

                                        </div>

                                    )
                                )}

                            </div>

                        )}

                    </ProfileCard>


                    {/* =============================================
                        CERTIFICATIONS
                    ============================================= */}

                    <ProfileCard
                        title="Certifications & Achievements"
                        icon={<Award />}
                    >

                        <div className="tp-cert-grid">

                            <InfoBlock
                                icon={<Award />}
                                title="Certifications"
                                value={
                                    details.certifications
                                }
                            />

                            <InfoBlock
                                icon={<Award />}
                                title="Achievements"
                                value={
                                    details.achievements
                                }
                            />

                            <InfoBlock
                                icon={<BookOpen />}
                                title="Notable Projects"
                                value={
                                    details.notableProjects
                                }
                            />

                        </div>

                    </ProfileCard>


                    {/* =============================================
                        ADDITIONAL INFORMATION
                    ============================================= */}

                    <ProfileCard
                        title="Additional Information"
                        icon={
                            <Languages />
                        }
                    >

                        <div className="tp-other-grid">

                            <InfoBlock
                                icon={
                                    <Languages />
                                }
                                title="Languages Known"
                                value={
                                    details.languagesKnown
                                }
                            />

                            <InfoBlock
                                icon={
                                    <MapPin />
                                }
                                title="Preferred Locations"
                                value={
                                    details.preferredLocations
                                }
                            />

                            <InfoBlock
                                icon={
                                    <BriefcaseBusiness />
                                }
                                title="Industry Experience"
                                value={
                                    details.industryExperience
                                }
                                suffix={
                                    details.industryExperience
                                        ? " Years"
                                        : ""
                                }
                            />

                        </div>

                    </ProfileCard>


                    {/* =============================================
                        PROFESSIONAL LINKS
                    ============================================= */}

                    <ProfileCard
                        title="Professional Links"
                        icon={<Globe />}
                    >

                        <div className="tp-links">

                            {details.linkedinUrl && (

                                <a
                                    href={
                                        details.linkedinUrl
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                >

                                    LinkedIn

                                    <ExternalLink
                                        size={14}
                                    />

                                </a>

                            )}


                            {details.githubUrl && (

                                <a
                                    href={
                                        details.githubUrl
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                >

                                    GitHub

                                    <ExternalLink
                                        size={14}
                                    />

                                </a>

                            )}


                            {details.portfolioUrl && (

                                <a
                                    href={
                                        details.portfolioUrl
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                >

                                    <Globe
                                        size={16}
                                    />

                                    Portfolio

                                    <ExternalLink
                                        size={14}
                                    />

                                </a>

                            )}


                            {!details.linkedinUrl &&
                                !details.githubUrl &&
                                !details.portfolioUrl && (

                                    <Empty
                                        text="No professional links added."
                                    />

                                )}

                        </div>

                    </ProfileCard>

                </main>


                {/* =================================================
                    RIGHT 30% SIDEBAR
                ================================================= */}

                <aside className="tp-sidebar">


                    {/* =============================================
                        PROFILE COMPLETION
                    ============================================= */}

                    <div className="tp-side-card tp-completion-card">

                        <div className="tp-side-card-header">

                            <div className="tp-side-icon">

                                <UserCheck
                                    size={18}
                                />

                            </div>

                            <div>

                                <h3>
                                    Profile Completion
                                </h3>

                                <p>
                                    Keep your profile updated
                                </p>

                            </div>

                        </div>


                        <div className="tp-completion-value">

                            <strong>
                                {completion}%
                            </strong>

                            <span>
                                Complete
                            </span>

                        </div>


                        <div className="tp-progress">

                            <div
                                className="tp-progress-bar"
                                style={{
                                    width:
                                        `${completion}%`
                                }}
                            />

                        </div>


                        <button
                            type="button"
                            className="tp-side-action"
                            onClick={
                                openProfileEdit
                            }
                        >

                            Complete Profile

                            <ChevronRight
                                size={16}
                            />

                        </button>

                    </div>


                    {/* =============================================
                        DOWNLOAD CV
                    ============================================= */}

                    <div className="tp-side-card tp-cv-card">

                        <div className="tp-cv-icon">

                            <FileText
                                size={26}
                            />

                        </div>


                        <h3>
                            Your Resume
                        </h3>


                        <p>
                            Download your latest professional
                            profile as a CV.
                        </p>


                        <button
                            type="button"
                            className="tp-download-cv"
                            onClick={
                                handleDownloadCV
                            }
                            disabled={
                                cvDownloading
                            }
                        >

                            {cvDownloading ? (

                                <>

                                    <Loader2
                                        size={17}
                                        className="tp-spin"
                                    />

                                    Generating...

                                </>

                            ) : (

                                <>

                                    <Download
                                        size={17}
                                    />

                                    Download CV

                                </>

                            )}

                        </button>


                        {cvDownloading && (

                            <>

                                <div className="tp-cv-progress-track">

                                    <div
                                        className="tp-cv-progress-fill"
                                        style={{
                                            width: `${downloadProgress}%`
                                        }}
                                    />

                                </div>

                                <div className="tp-cv-progress-label">
                                    {downloadProgress}%
                                </div>

                            </>

                        )}

                    </div>


                    {/* =============================================
                        QUICK NAVIGATION
                    ============================================= */}

                    <div className="tp-side-card">

                        <div className="tp-side-card-heading">

                            Quick Navigation

                        </div>


                        <button
                            type="button"
                            className="tp-side-link"
                            onClick={() =>
                                goTo("/dashboard")
                            }
                        >

                            <span>

                                <LayoutDashboard
                                    size={17}
                                />

                                Dashboard

                            </span>

                            <ChevronRight
                                size={16}
                            />

                        </button>


                        <button
                            type="button"
                            className="tp-side-link"
                            onClick={() =>
                                goTo(
                                    "/job-applications"
                                )
                            }
                        >

                            <span>

                                <ClipboardList
                                    size={17}
                                />

                                Job Applications

                            </span>

                            <ChevronRight
                                size={16}
                            />

                        </button>


                        <button
                            type="button"
                            className="tp-side-link"
                            onClick={() =>
                                goTo("/jobs")
                            }
                        >

                            <span>

                                <BriefcaseBusiness
                                    size={17}
                                />

                                Browse Jobs

                            </span>

                            <ChevronRight
                                size={16}
                            />

                        </button>


                        <button
                            type="button"
                            className="tp-side-link active"
                            onClick={() =>
                                goTo(
                                    "/trainer-profile"
                                )
                            }
                        >

                            <span>

                                <UserRound
                                    size={17}
                                />

                                My Profile

                            </span>

                            <ChevronRight
                                size={16}
                            />

                        </button>

                    </div>


                    {/* =============================================
                        PROFILE INFORMATION
                    ============================================= */}

                    <div className="tp-side-card">

                        <div className="tp-side-card-heading">

                            Profile Information

                        </div>


                        <div className="tp-side-info">

                            <Mail size={16} />

                            <span>
                                {
                                    trainer.email ||
                                    "Email not available"
                                }
                            </span>

                        </div>


                        <div className="tp-side-info">

                            <Phone size={16} />

                            <span>
                                {
                                    trainer.phone ||
                                    "Phone not available"
                                }
                            </span>

                        </div>


                        <div className="tp-side-info">

                            <MapPin size={16} />

                            <span>

                                {[
                                    trainer.city,
                                    trainer.state
                                ]
                                    .filter(Boolean)
                                    .join(", ") ||
                                    "Location not specified"}

                            </span>

                        </div>

                    </div>

                </aside>

            </div>


            {/* =================================================
                HIDDEN CV DOCUMENT
            ================================================= */}

            <div
                ref={resumeRef}
                className="tp-cv-document"
            >

                <div className="tp-cv-header">

                    <div>

                        <h1>
                            {
                                trainer.name ||
                                "Trainer Name"
                            }
                        </h1>

                        <h2>

                            {
                                details.professionalTitle ||
                                details.currentDesignation ||
                                "Professional Trainer"
                            }

                        </h2>

                    </div>

                </div>


                <div className="tp-cv-contact">

                    {trainer.email && (
                        <span>
                            Email: {trainer.email}
                        </span>
                    )}

                    {trainer.phone && (
                        <span>
                            Phone: {trainer.phone}
                        </span>
                    )}

                    {(trainer.city ||
                        trainer.state) && (

                        <span>

                            Location:{" "}

                            {[
                                trainer.city,
                                trainer.state
                            ]
                                .filter(Boolean)
                                .join(", ")}

                        </span>

                    )}

                </div>


                {details.profileSummary && (

                    <CvSection
                        title="Professional Summary"
                    >

                        <p>
                            {
                                details.profileSummary
                            }
                        </p>

                    </CvSection>

                )}


                {skills.length > 0 && (

                    <CvSection
                        title="Technical Skills"
                    >

                        <p>
                            {skills.join(" • ")}
                        </p>

                    </CvSection>

                )}


                {experience.length > 0 && (

                    <CvSection
                        title="Professional Experience"
                    >

                        {experience.map(
                            item => (

                                <div
                                    className="tp-cv-item"
                                    key={
                                        item.id
                                    }
                                >

                                    <h3>

                                        {
                                            item.designation ||
                                            "Designation"
                                        }

                                    </h3>

                                    <strong>

                                        {
                                            item.companyName ||
                                            "Company"
                                        }

                                    </strong>

                                    <p>

                                        {item.startDate
                                            ? formatDate(
                                                item.startDate
                                            )
                                            : ""}

                                        {" - "}

                                        {item.isCurrent
                                            ? "Present"
                                            : item.endDate
                                                ? formatDate(
                                                    item.endDate
                                                )
                                                : ""}

                                    </p>

                                    {item.technologiesUsed && (

                                        <p>
                                            <strong>
                                                Technologies:
                                            </strong>{" "}
                                            {
                                                item.technologiesUsed
                                            }
                                        </p>

                                    )}

                                    {item.jobDescription && (

                                        <p>
                                            {
                                                item.jobDescription
                                            }
                                        </p>

                                    )}

                                </div>

                            )
                        )}

                    </CvSection>

                )}


                {education.length > 0 && (

                    <CvSection
                        title="Education"
                    >

                        {education.map(
                            item => (

                                <div
                                    className="tp-cv-item"
                                    key={
                                        item.id
                                    }
                                >

                                    <h3>

                                        {
                                            item.degree ||
                                            "Degree"
                                        }

                                    </h3>

                                    {item.specialization && (

                                        <p>
                                            {
                                                item.specialization
                                            }
                                        </p>

                                    )}

                                    <p>

                                        {
                                            item.college ||
                                            item.university ||
                                            ""
                                        }

                                    </p>

                                    <p>

                                        {
                                            item.startYear ||
                                            ""
                                        }

                                        {" - "}

                                        {
                                            item.endYear ||
                                            "Present"
                                        }

                                    </p>

                                </div>

                            )
                        )}

                    </CvSection>

                )}


                {(details.certifications ||
                    details.achievements) && (

                    <CvSection
                        title="Certifications & Achievements"
                    >

                        {details.certifications && (

                            <p>

                                <strong>
                                    Certifications:
                                </strong>{" "}

                                {
                                    details.certifications
                                }

                            </p>

                        )}

                        {details.achievements && (

                            <p>

                                <strong>
                                    Achievements:
                                </strong>{" "}

                                {
                                    details.achievements
                                }

                            </p>

                        )}

                    </CvSection>

                )}


                {(details.linkedinUrl ||
                    details.githubUrl ||
                    details.portfolioUrl) && (

                    <CvSection
                        title="Professional Links"
                    >

                        {details.linkedinUrl && (
                            <p>
                                LinkedIn:{" "}
                                {
                                    details.linkedinUrl
                                }
                            </p>
                        )}

                        {details.githubUrl && (
                            <p>
                                GitHub:{" "}
                                {
                                    details.githubUrl
                                }
                            </p>
                        )}

                        {details.portfolioUrl && (
                            <p>
                                Portfolio:{" "}
                                {
                                    details.portfolioUrl
                                }
                            </p>
                        )}

                    </CvSection>

                )}

            </div>


            {/* =================================================
                MODALS
            ================================================= */}

            {activeModal === "profile" && (

                <ProfileModal
                    details={details}
                    saving={saving}
                    onClose={closeModal}
                    onSave={handleProfileSave}
                />

            )}


            {activeModal === "trainerInfo" && (

                <TrainerInfoModal
                    trainer={trainer}
                    saving={saving}
                    onClose={closeModal}
                    onSave={handleTrainerInfoSave}
                />

            )}


            {activeModal === "education" && (

                <EducationModal
                    data={editingEducation}
                    saving={saving}
                    onClose={closeModal}
                    onSave={handleEducationSave}
                />

            )}


            {activeModal === "experience" && (

                <ExperienceModal
                    data={editingExperience}
                    saving={saving}
                    onClose={closeModal}
                    onSave={handleExperienceSave}
                />

            )}

        </div>
    );
}


/* =========================================================
   PROFILE CARD
========================================================= */

function ProfileCard({
    title,
    icon,
    children,
    action
}) {

    return (

        <section className="tp-card">

            <div className="tp-card-header">

                <div className="tp-card-title">

                    <span className="tp-card-icon">
                        {icon}
                    </span>

                    <h2>
                        {title}
                    </h2>

                </div>

                {action}

            </div>

            <div className="tp-card-body">
                {children}
            </div>

        </section>
    );
}


/* =========================================================
   STAT
========================================================= */

function Stat({
    icon,
    value,
    label
}) {

    return (

        <div className="tp-stat">

            <div className="tp-stat-icon">
                {icon}
            </div>

            <div>

                <strong>
                    {value}
                </strong>

                <span>
                    {label}
                </span>

            </div>

        </div>
    );
}


/* =========================================================
   TECH ITEM
========================================================= */

function TechItem({
    icon,
    title,
    value
}) {

    return (

        <div className="tp-tech-item">

            <div className="tp-tech-icon">
                {icon}
            </div>

            <div>

                <label>
                    {title}
                </label>

                <p>
                    {value || "Not specified"}
                </p>

            </div>

        </div>
    );
}


/* =========================================================
   INFO BLOCK
========================================================= */

function InfoBlock({
    icon,
    title,
    value,
    suffix = ""
}) {

    return (

        <div className="tp-info-block">

            <div className="tp-info-icon">
                {icon}
            </div>

            <div>

                <label>
                    {title}
                </label>

                <p>
                    {value
                        ? `${value}${suffix}`
                        : "Not specified"}
                </p>

            </div>

        </div>
    );
}


/* =========================================================
   EMPTY
========================================================= */

function Empty({
    text
}) {

    return (

        <div className="tp-empty">

            <BookOpen size={25} />

            <span>
                {text}
            </span>

        </div>
    );
}


/* =========================================================
   INPUT
========================================================= */

function Input({
    label,
    name,
    value,
    onChange,
    type = "text",
    placeholder = "",
    step,
    min,
    max
}) {

    return (

        <div className="tp-form-group">

            <label>
                {label}
            </label>

            <input
                type={type}
                name={name}
                value={value ?? ""}
                onChange={onChange}
                placeholder={placeholder}
                step={step}
                min={min}
                max={max}
            />

        </div>
    );
}


/* =========================================================
   TEXTAREA
========================================================= */

function Textarea({
    label,
    name,
    value,
    onChange,
    placeholder = "",
    rows = 4
}) {

    return (

        <div className="tp-form-group">

            <label>
                {label}
            </label>

            <textarea
                name={name}
                value={value ?? ""}
                onChange={onChange}
                placeholder={placeholder}
                rows={rows}
            />

        </div>
    );
}


/* =========================================================
   SELECT
========================================================= */

function Select({
    label,
    name,
    value,
    onChange,
    options
}) {

    return (

        <div className="tp-form-group">

            <label>
                {label}
            </label>

            <select
                name={name}
                value={value ?? ""}
                onChange={onChange}
            >

                {options.map(
                    option => (

                        <option
                            key={option}
                            value={option}
                        >
                            {option}
                        </option>

                    )
                )}

            </select>

        </div>
    );
}


/* =========================================================
   MODAL
========================================================= */

function Modal({
    title,
    children,
    onClose,
    onSave,
    saving,
    saveText = "Save"
}) {

    return (

        <div
            className="tp-modal-overlay"
            onMouseDown={e => {

                if (
                    e.target === e.currentTarget &&
                    !saving
                ) {

                    onClose();
                }

            }}
        >

            <div
                className="tp-modal"
                onMouseDown={e =>
                    e.stopPropagation()
                }
            >

                <div className="tp-modal-header">

                    <h2>
                        {title}
                    </h2>

                    <button
                        type="button"
                        className="tp-modal-close"
                        onClick={onClose}
                        disabled={saving}
                    >

                        <X size={20} />

                    </button>

                </div>


                <div className="tp-modal-body">

                    {children}

                </div>


                <div className="tp-modal-footer">

                    <button
                        type="button"
                        className="tp-cancel-btn"
                        onClick={onClose}
                        disabled={saving}
                    >

                        Cancel

                    </button>


                    <button
                        type="button"
                        className="tp-save-btn"
                        onClick={onSave}
                        disabled={saving}
                    >

                        {saving ? (

                            <>

                                <Loader2
                                    size={16}
                                    className="tp-spin"
                                />

                                Saving...

                            </>

                        ) : (

                            <>

                                <Save size={16} />

                                {saveText}

                            </>

                        )}

                    </button>

                </div>

            </div>

        </div>
    );
}


/* =========================================================
   PROFILE MODAL
========================================================= */

function ProfileModal({
    details,
    saving,
    onClose,
    onSave
}) {

    const [form, setForm] =
        useState(() => ({

            professionalTitle:
                details?.professionalTitle || "",

            profileSummary:
                details?.profileSummary || "",

            currentOrganization:
                details?.currentOrganization || "",

            currentDesignation:
                details?.currentDesignation || "",

            totalExperience:
                details?.totalExperience ?? "",

            trainingExperience:
                details?.trainingExperience ?? "",

            industryExperience:
                details?.industryExperience ?? "",

            technicalSkills:
                details?.technicalSkills || "",

            programmingLanguages:
                details?.programmingLanguages || "",

            frameworks:
                details?.frameworks || "",

            databaseTechnologies:
                details?.databaseTechnologies || "",

            cloudTools:
                details?.cloudTools || "",

            devopsTools:
                details?.devopsTools || "",

            certifications:
                details?.certifications || "",

            achievements:
                details?.achievements || "",

            notableProjects:
                details?.notableProjects || "",

            linkedinUrl:
                details?.linkedinUrl || "",

            githubUrl:
                details?.githubUrl || "",

            portfolioUrl:
                details?.portfolioUrl || "",

            languagesKnown:
                details?.languagesKnown || "",

            teachingMode:
                details?.teachingMode || "",

            preferredLocations:
                details?.preferredLocations || ""

        }));


    const handleChange = e => {

        const {
            name,
            value
        } = e.target;

        setForm(prev => ({

            ...prev,

            [name]: value

        }));
    };


    const submit = () => {

        onSave({

            ...form,

            totalExperience:
                form.totalExperience === ""
                    ? null
                    : Number(
                        form.totalExperience
                    ),

            trainingExperience:
                form.trainingExperience === ""
                    ? null
                    : Number(
                        form.trainingExperience
                    ),

            industryExperience:
                form.industryExperience === ""
                    ? null
                    : Number(
                        form.industryExperience
                    )

        });
    };


    return (

        <Modal
            title="Edit Professional Profile"
            onClose={onClose}
            onSave={submit}
            saving={saving}
            saveText="Update Profile"
        >

            <div className="tp-form-grid">

                <Input
                    label="Professional Title"
                    name="professionalTitle"
                    value={
                        form.professionalTitle
                    }
                    onChange={handleChange}
                    placeholder="Java Full Stack Trainer"
                />

                <Input
                    label="Current Organization"
                    name="currentOrganization"
                    value={
                        form.currentOrganization
                    }
                    onChange={handleChange}
                    placeholder="Company / Institute"
                />

                <Input
                    label="Current Designation"
                    name="currentDesignation"
                    value={
                        form.currentDesignation
                    }
                    onChange={handleChange}
                    placeholder="Senior Technical Trainer"
                />

                <Input
                    label="Teaching Mode"
                    name="teachingMode"
                    value={
                        form.teachingMode
                    }
                    onChange={handleChange}
                    placeholder="Online / Offline / Hybrid"
                />

                <Input
                    label="Total Experience"
                    name="totalExperience"
                    type="number"
                    step="0.1"
                    min="0"
                    value={
                        form.totalExperience
                    }
                    onChange={handleChange}
                    placeholder="5"
                />

                <Input
                    label="Training Experience"
                    name="trainingExperience"
                    type="number"
                    step="0.1"
                    min="0"
                    value={
                        form.trainingExperience
                    }
                    onChange={handleChange}
                    placeholder="3"
                />

                <Input
                    label="Industry Experience"
                    name="industryExperience"
                    type="number"
                    step="0.1"
                    min="0"
                    value={
                        form.industryExperience
                    }
                    onChange={handleChange}
                    placeholder="2"
                />

            </div>


            <Textarea
                label="Profile Summary"
                name="profileSummary"
                value={
                    form.profileSummary
                }
                onChange={handleChange}
                placeholder="Write professional summary..."
                rows={5}
            />


            <div className="tp-form-section-title">
                Technical Skills
            </div>


            <Textarea
                label="Technical Skills"
                name="technicalSkills"
                value={
                    form.technicalSkills
                }
                onChange={handleChange}
                placeholder="Java, Spring Boot, React, SQL"
            />


            <div className="tp-form-grid">

                <Input
                    label="Programming Languages"
                    name="programmingLanguages"
                    value={
                        form.programmingLanguages
                    }
                    onChange={handleChange}
                    placeholder="Java, C++, Python"
                />

                <Input
                    label="Frameworks"
                    name="frameworks"
                    value={
                        form.frameworks
                    }
                    onChange={handleChange}
                    placeholder="Spring Boot, React"
                />

                <Input
                    label="Databases"
                    name="databaseTechnologies"
                    value={
                        form.databaseTechnologies
                    }
                    onChange={handleChange}
                    placeholder="MySQL, PostgreSQL"
                />

                <Input
                    label="Cloud Tools"
                    name="cloudTools"
                    value={
                        form.cloudTools
                    }
                    onChange={handleChange}
                    placeholder="AWS, Azure"
                />

                <Input
                    label="DevOps Tools"
                    name="devopsTools"
                    value={
                        form.devopsTools
                    }
                    onChange={handleChange}
                    placeholder="Docker, Jenkins"
                />

                <Input
                    label="Languages Known"
                    name="languagesKnown"
                    value={
                        form.languagesKnown
                    }
                    onChange={handleChange}
                    placeholder="English, Hindi"
                />

            </div>


            <div className="tp-form-section-title">
                Certifications & Achievements
            </div>


            <Textarea
                label="Certifications"
                name="certifications"
                value={
                    form.certifications
                }
                onChange={handleChange}
                placeholder="AWS Certified, Java Certification..."
            />


            <Textarea
                label="Achievements"
                name="achievements"
                value={
                    form.achievements
                }
                onChange={handleChange}
                placeholder="Awards, recognitions, achievements..."
            />


            <Textarea
                label="Notable Projects"
                name="notableProjects"
                value={
                    form.notableProjects
                }
                onChange={handleChange}
                placeholder="Describe notable projects..."
            />


            <div className="tp-form-section-title">
                Professional Links
            </div>


            <div className="tp-form-grid">

                <Input
                    label="LinkedIn URL"
                    name="linkedinUrl"
                    value={
                        form.linkedinUrl
                    }
                    onChange={handleChange}
                    placeholder="https://linkedin.com/in/..."
                />

                <Input
                    label="GitHub URL"
                    name="githubUrl"
                    value={
                        form.githubUrl
                    }
                    onChange={handleChange}
                    placeholder="https://github.com/..."
                />

                <Input
                    label="Portfolio URL"
                    name="portfolioUrl"
                    value={
                        form.portfolioUrl
                    }
                    onChange={handleChange}
                    placeholder="https://..."
                />

                <Input
                    label="Preferred Locations"
                    name="preferredLocations"
                    value={
                        form.preferredLocations
                    }
                    onChange={handleChange}
                    placeholder="Delhi, Bangalore, Pune"
                />

            </div>

        </Modal>
    );
}


/* =========================================================
   TRAINER INFO MODAL (edits the `trainers` table)
========================================================= */

function TrainerInfoModal({
    trainer,
    saving,
    onClose,
    onSave
}) {

    const [form, setForm] =
        useState(() => ({

            name:
                trainer?.name || "",

            phone:
                trainer?.phone || "",

            secondaryPhone:
                trainer?.secondaryPhone || "",

            email:
                trainer?.email || "",

            secondaryEmail:
                trainer?.secondaryEmail || "",

            age:
                trainer?.age ?? "",

            experience:
                trainer?.experience ?? "",

            state:
                trainer?.state || "",

            city:
                trainer?.city || "",

            pincode:
                trainer?.pincode || "",

            skills:
                trainer?.skills || "",

            source:
                trainer?.source || "",

            rate:
                trainer?.rate ?? "",

            remark:
                trainer?.remark || "",

            status:
                trainer?.status ||
                STATUS_OPTIONS[0]

        }));


    const handleChange = e => {

        const {
            name,
            value
        } = e.target;

        setForm(prev => ({

            ...prev,

            [name]: value

        }));
    };


    const submit = () => {

        onSave({

            ...form,

            age:
                form.age === ""
                    ? null
                    : Number(
                        form.age
                    ),

            experience:
                form.experience === ""
                    ? null
                    : Number(
                        form.experience
                    ),

            rate:
                form.rate === ""
                    ? null
                    : Number(
                        form.rate
                    )

        });
    };


    return (

        <Modal
            title="Edit Trainer Information"
            onClose={onClose}
            onSave={submit}
            saving={saving}
            saveText="Update Details"
        >

            <div className="tp-form-grid">

                <Input
                    label="Full Name"
                    name="name"
                    value={
                        form.name
                    }
                    onChange={handleChange}
                    placeholder="Trainer name"
                />

                <Input
                    label="Phone"
                    name="phone"
                    value={
                        form.phone
                    }
                    onChange={handleChange}
                    placeholder="Primary phone"
                />

                <Input
                    label="Secondary Phone"
                    name="secondaryPhone"
                    value={
                        form.secondaryPhone
                    }
                    onChange={handleChange}
                    placeholder="Alternate phone"
                />

                <Input
                    label="Email"
                    name="email"
                    type="email"
                    value={
                        form.email
                    }
                    onChange={handleChange}
                    placeholder="Primary email"
                />

                <Input
                    label="Secondary Email"
                    name="secondaryEmail"
                    type="email"
                    value={
                        form.secondaryEmail
                    }
                    onChange={handleChange}
                    placeholder="Alternate email"
                />

                <Input
                    label="Age"
                    name="age"
                    type="number"
                    min="0"
                    value={
                        form.age
                    }
                    onChange={handleChange}
                    placeholder="30"
                />

                <Input
                    label="Experience (Years)"
                    name="experience"
                    type="number"
                    step="0.1"
                    min="0"
                    value={
                        form.experience
                    }
                    onChange={handleChange}
                    placeholder="5"
                />

                <Input
                    label="State"
                    name="state"
                    value={
                        form.state
                    }
                    onChange={handleChange}
                    placeholder="Madhya Pradesh"
                />

                <Input
                    label="City"
                    name="city"
                    value={
                        form.city
                    }
                    onChange={handleChange}
                    placeholder="Gwalior"
                />

                <Input
                    label="Pincode"
                    name="pincode"
                    value={
                        form.pincode
                    }
                    onChange={handleChange}
                    placeholder="474001"
                />

                <Input
                    label="Source"
                    name="source"
                    value={
                        form.source
                    }
                    onChange={handleChange}
                    placeholder="Referral / Naukri / LinkedIn"
                />

                <Input
                    label="Rate"
                    name="rate"
                    type="number"
                    step="0.01"
                    min="0"
                    value={
                        form.rate
                    }
                    onChange={handleChange}
                    placeholder="1500"
                />

                <Select
                    label="Status"
                    name="status"
                    value={
                        form.status
                    }
                    onChange={handleChange}
                    options={
                        STATUS_OPTIONS
                    }
                />

            </div>


            <Textarea
                label="Skills"
                name="skills"
                value={
                    form.skills
                }
                onChange={handleChange}
                placeholder="Java, Spring Boot, React, SQL"
                rows={3}
            />


            <Textarea
                label="Remark"
                name="remark"
                value={
                    form.remark
                }
                onChange={handleChange}
                placeholder="Internal remarks about this trainer..."
                rows={4}
            />

        </Modal>
    );
}


/* =========================================================
   EDUCATION MODAL
========================================================= */

function EducationModal({
    data,
    saving,
    onClose,
    onSave
}) {

    const [form, setForm] =
        useState(() => ({

            degree:
                data?.degree || "",

            specialization:
                data?.specialization || "",

            university:
                data?.university || "",

            college:
                data?.college || "",

            startYear:
                data?.startYear ?? "",

            endYear:
                data?.endYear ?? "",

            percentage:
                data?.percentage ?? "",

            cgpa:
                data?.cgpa ?? "",

            educationType:
                data?.educationType || "",

            description:
                data?.description || ""

        }));


    const handleChange = e => {

        const {
            name,
            value
        } = e.target;

        setForm(prev => ({

            ...prev,

            [name]: value

        }));
    };


    const submit = () => {

        onSave({

            ...form,

            startYear:
                form.startYear === ""
                    ? null
                    : Number(
                        form.startYear
                    ),

            endYear:
                form.endYear === ""
                    ? null
                    : Number(
                        form.endYear
                    ),

            percentage:
                form.percentage === ""
                    ? null
                    : Number(
                        form.percentage
                    ),

            cgpa:
                form.cgpa === ""
                    ? null
                    : Number(
                        form.cgpa
                    )

        });
    };


    return (

        <Modal
            title={
                data
                    ? "Edit Education"
                    : "Add Education"
            }
            onClose={onClose}
            onSave={submit}
            saving={saving}
            saveText={
                data
                    ? "Update Education"
                    : "Add Education"
            }
        >

            <div className="tp-form-grid">

                <Input
                    label="Degree"
                    name="degree"
                    value={
                        form.degree
                    }
                    onChange={handleChange}
                    placeholder="B.Tech / M.Tech / MCA"
                />

                <Input
                    label="Specialization"
                    name="specialization"
                    value={
                        form.specialization
                    }
                    onChange={handleChange}
                    placeholder="Computer Science"
                />

                <Input
                    label="University"
                    name="university"
                    value={
                        form.university
                    }
                    onChange={handleChange}
                    placeholder="University name"
                />

                <Input
                    label="College / Institute"
                    name="college"
                    value={
                        form.college
                    }
                    onChange={handleChange}
                    placeholder="College name"
                />

                <Input
                    label="Start Year"
                    name="startYear"
                    type="number"
                    min="1900"
                    max="2100"
                    value={
                        form.startYear
                    }
                    onChange={handleChange}
                    placeholder="2018"
                />

                <Input
                    label="End Year"
                    name="endYear"
                    type="number"
                    min="1900"
                    max="2100"
                    value={
                        form.endYear
                    }
                    onChange={handleChange}
                    placeholder="2022"
                />

                <Input
                    label="Percentage"
                    name="percentage"
                    type="number"
                    step="0.01"
                    min="0"
                    max="100"
                    value={
                        form.percentage
                    }
                    onChange={handleChange}
                    placeholder="75"
                />

                <Input
                    label="CGPA"
                    name="cgpa"
                    type="number"
                    step="0.01"
                    min="0"
                    max="10"
                    value={
                        form.cgpa
                    }
                    onChange={handleChange}
                    placeholder="8.2"
                />

                <Input
                    label="Education Type"
                    name="educationType"
                    value={
                        form.educationType
                    }
                    onChange={handleChange}
                    placeholder="Full Time"
                />

            </div>


            <Textarea
                label="Description"
                name="description"
                value={
                    form.description
                }
                onChange={handleChange}
                placeholder="Additional education details..."
                rows={4}
            />

        </Modal>
    );
}


/* =========================================================
   EXPERIENCE MODAL
========================================================= */

function ExperienceModal({
    data,
    saving,
    onClose,
    onSave
}) {

    const [form, setForm] =
        useState(() => ({

            companyName:
                data?.companyName || "",

            designation:
                data?.designation || "",

            employmentType:
                data?.employmentType || "",

            location:
                data?.location || "",

            startDate:
                data?.startDate || "",

            endDate:
                data?.endDate || "",

            isCurrent:
                Boolean(
                    data?.isCurrent
                ),

            experienceYears:
                data?.experienceYears ?? "",

            jobDescription:
                data?.jobDescription || "",

            responsibilities:
                data?.responsibilities || "",

            technologiesUsed:
                data?.technologiesUsed || ""

        }));


    const handleChange = e => {

        const {
            name,
            value,
            type,
            checked
        } = e.target;

        setForm(prev => ({

            ...prev,

            [name]:
                type === "checkbox"
                    ? checked
                    : value

        }));
    };


    const submit = () => {

        onSave({

            ...form,

            startDate:
                form.startDate ||
                null,

            endDate:
                form.isCurrent
                    ? null
                    : form.endDate ||
                    null,

            isCurrent:
                Boolean(
                    form.isCurrent
                ),

            experienceYears:
                form.experienceYears === ""
                    ? null
                    : Number(
                        form.experienceYears
                    )

        });
    };


    return (

        <Modal
            title={
                data
                    ? "Edit Experience"
                    : "Add Experience"
            }
            onClose={onClose}
            onSave={submit}
            saving={saving}
            saveText={
                data
                    ? "Update Experience"
                    : "Add Experience"
            }
        >

            <div className="tp-form-grid">

                <Input
                    label="Company Name"
                    name="companyName"
                    value={
                        form.companyName
                    }
                    onChange={handleChange}
                    placeholder="Company / Institute"
                />

                <Input
                    label="Designation"
                    name="designation"
                    value={
                        form.designation
                    }
                    onChange={handleChange}
                    placeholder="Technical Trainer"
                />

                <Input
                    label="Employment Type"
                    name="employmentType"
                    value={
                        form.employmentType
                    }
                    onChange={handleChange}
                    placeholder="Full Time / Contract"
                />

                <Input
                    label="Location"
                    name="location"
                    value={
                        form.location
                    }
                    onChange={handleChange}
                    placeholder="Bangalore"
                />

                <Input
                    label="Start Date"
                    name="startDate"
                    type="date"
                    value={
                        form.startDate
                    }
                    onChange={handleChange}
                />

                {!form.isCurrent && (

                    <Input
                        label="End Date"
                        name="endDate"
                        type="date"
                        value={
                            form.endDate
                        }
                        onChange={
                            handleChange
                        }
                    />

                )}


                <Input
                    label="Experience Years"
                    name="experienceYears"
                    type="number"
                    step="0.1"
                    min="0"
                    value={
                        form.experienceYears
                    }
                    onChange={
                        handleChange
                    }
                    placeholder="2.5"
                />

            </div>


            <label className="tp-checkbox">

                <input
                    type="checkbox"
                    name="isCurrent"
                    checked={
                        form.isCurrent
                    }
                    onChange={
                        handleChange
                    }
                />

                <span>
                    I currently work here
                </span>

            </label>


            <Textarea
                label="Job Description"
                name="jobDescription"
                value={
                    form.jobDescription
                }
                onChange={
                    handleChange
                }
                placeholder="Describe your role..."
                rows={4}
            />


            <Textarea
                label="Responsibilities"
                name="responsibilities"
                value={
                    form.responsibilities
                }
                onChange={
                    handleChange
                }
                placeholder="Key responsibilities..."
                rows={4}
            />


            <Textarea
                label="Technologies Used"
                name="technologiesUsed"
                value={
                    form.technologiesUsed
                }
                onChange={
                    handleChange
                }
                placeholder="Java, Spring Boot, React, AWS"
                rows={3}
            />

        </Modal>
    );
}


/* =========================================================
   CV SECTION
========================================================= */

function CvSection({
    title,
    children
}) {

    return (

        <section className="tp-cv-section">

            <h2>
                {title}
            </h2>

            <div>
                {children}
            </div>

        </section>
    );
}


/* =========================================================
   DATE FORMAT
========================================================= */

function formatDate(value) {

    if (!value) {
        return "";
    }

    try {

        return new Date(value)
            .toLocaleDateString(
                "en-IN",
                {
                    month: "short",
                    year: "numeric"
                }
            );

    } catch {

        return value;
    }
}